<div class="tw-flex tw-flex-col tw-h-full">
    <div class="tw-flex tw-items-center tw-gap-0 tw-mb-6">
        <div class="tw-flex tw-items-center tw-flex-grow">
            <h5 class="tw-text-black tw-font-bold tw-text-[1.25rem]">
                {{ name }}
            </h5>
            <div
                tabindex="0"
                *ngIf="showTrialInvite"
                class="invite"
                (click)="inviteTrialUsers()"
                (keyup.enter)="inviteTrialUsers()"
                buttonDataTest="inviteTrialUserButton"
                [ngClass]="{ 'btn-disabled': (invitesLoading$ | async) }"
            >
                <span class="tw-mr-1 tw-text-md">&#43;</span>
                <span class="tw-font-sm" translate>v3-global-invite</span>
                <app-loader *ngIf="invitesLoading$ | async" loaderType="button" loaderSize="s" loaderColor="white" overlayColor="secondary"></app-loader>
            </div>
        </div>
        <form [formGroup]="form">
            <div class="tw-min-w-[10rem] tw-max-w-[20rem]">
                <app-form-dropdown-single-select controlName="range" label="Week" [items]="dropdownItems" />
            </div>
        </form>
    </div>

    <!-- Loader - block -->
    <div *ngIf="loading && !leaderboard" class="tw-py-6">
        <app-loader loaderColor="default"></app-loader>
    </div>

    <div class="tw-relative">
        <div
            *ngFor="let item of leaderboard; let last = last"
            class="item"
            [elementDataTest]="item.id"
            [ngClass]="[last ? '' : 'tw-mb-2', item.me ? 'b-' + itemTrendColor(item) : 'tw-border-black']"
        >
            <div class="item-content">
                <div
                    class="tw-relative tw-inline-flex tw-justify-center tw-items-center tw-rounded-full tw-border tw-border-solid tw-box-content tw-me-3 tw-font-bold"
                    [ngClass]="['b-' + itemTrendColor(item), item.rank > 99 ? 'tw-size-8.5' : 'tw-size-6.5']"
                >
                    <span [ngClass]="['tw-text-' + itemTrendColor(item), item.rank > 99 ? 'tw-font-xs' : 'tw-font-sm']">{{ item.rank }}</span>
                </div>

                <div class="tw-flex-auto tw-px-0">
                    <span class="tw-font-sm tw-font-bold">{{ getUserFullName(item) }}</span>
                </div>
                <div>
                    <span class="tw-font-xs">{{ item.watched.seconds | time: { type: 'letter', round: 'down' } }}</span>
                </div>
                <div ariaHidden class="tw-ml-3">
                    <div [ngSwitch]="item.trend">
                        <div *ngSwitchCase="'success'">
                            <app-icon name="arrow-up" class="tw-fill-success tw-w-4 tw-h-4"></app-icon>
                        </div>
                        <div *ngSwitchCase="'muted'">
                            <div class="tw-rounded-full tw-size-4 tw-bg-black-10"></div>
                        </div>
                        <div *ngSwitchCase="'danger'">
                            <app-icon name="arrow-down" class="tw-fill-danger tw-w-4 tw-h-4"></app-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loader - overlay -->
        <app-loader *ngIf="loading && leaderboard" loaderType="cover" overlayColor="white"></app-loader>
    </div>

    <!-- Trial -->
    <div *ngIf="showTrialInvitesInfo" class="tw-mt-1 tw-mb-2 tw-h-100">
        <app-leaderboard-trial-invites-info></app-leaderboard-trial-invites-info>
    </div>
</div>
